import { AuthService } from '../../auth/auth.service';
import { CartService } from '../../services/cart.service';
import { CategoriesService } from '../../services/categories.service';

export function appInitializer(authService: AuthService, cartService: CartService, categoriesService: CategoriesService): () => Promise<void> {
  return async () => {
    try {
      await authService.loadSessionUser();
      if (authService.isAuthenticated()) {
        await Promise.all([
          authService.loadAddress(),
          cartService.load()
        ]);
      }
    } catch (error) {
      // Si ocurre un error al cargar la sesión, carrito, o dirección, logueamos el error pero seguimos adelante
      console.error('Error al cargar sesión o carrito:', error);
    }

    try {
      // De todos modos intentamos cargar las categorías, aunque algo más haya fallado
      await categoriesService.listCategoryInitializer();
    } catch (error) {
      // Si ocurre un error en las categorías, lo logueamos también
      console.error('Error al cargar categorías:', error);
    }
  };
}
